import React from 'react';

const MobileClose = () => (
    <svg className="mobile-close" width="40" height="40" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <circle fillOpacity=".4" fill="transparent" fillRule="nonzero" cx="20" cy="20" r="20"/>
            <path fill="#95979D" d="M22.0859182 27.433557c-.0703123.0703123-.1640623.1054685-.2812493.1054685-.117187 0-.2226555-.0351562-.3164055-.1054685l-7.3476387-7.3827949C14.0468747 19.9804497 14 19.8866998 14 19.7695127c0-.117187.0468747-.210937.1406247-.2812493l7.3476387-7.3827949c.09375-.0703123.1992185-.1054685.3164055-.1054685.117187 0 .210937.0351562.2812493.1054685l.7031233.7031233c.09375.0703124.1406247.1640623.1406247.2812494 0 .117187-.0468747.2226555-.1406247.3164054l-6.363266 6.3632661 6.363266 6.3632661c.09375.09375.1406247.1992185.1406247.3164055 0 .117187-.0468747.210937-.1406247.2812493l-.7031233.7031234z"/>
        </g>
    </svg>
);

export default MobileClose;
